import React, { useEffect, useState } from "react";

import "./PersonAvatar.css";

export const getPersonInitials = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!parts.length) return "RM";
  if (parts.length === 1) return parts[0].slice(0, 2).toLocaleUpperCase("es");
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toLocaleUpperCase("es");
};

const PersonAvatar = React.forwardRef(({
  src,
  name,
  alt,
  className = "",
  tone = "persona",
  loading = "lazy",
  decoding = "async",
  title,
  ...elementProps
}, ref) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [src]);

  if (src && !imageFailed) {
    return (
      <img
        ref={ref}
        {...elementProps}
        src={src}
        alt={alt ?? name ?? ""}
        className={className}
        loading={loading}
        decoding={decoding}
        title={title}
        onError={() => setImageFailed(true)}
      />
    );
  }

  return (
    <span
      ref={ref}
      {...elementProps}
      className={`person-avatar-fallback person-avatar-fallback--${tone} ${className}`.trim()}
      role="img"
      aria-label={`Fotografía no disponible${name ? ` para ${name}` : ""}`}
      title={title || name}
    >
      {getPersonInitials(name)}
    </span>
  );
});

PersonAvatar.displayName = "PersonAvatar";

export default PersonAvatar;
